import { render, staticRenderFns } from "./ItemImageUpload.vue?vue&type=template&id=09dbcbc4"
import script from "./ItemImageUpload.vue?vue&type=script&lang=js"
export * from "./ItemImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports